import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { DialogService } from "src/core/services/ui/dialog.service";
import { ControllerProps } from 'src/router';
import { ObjectUtils } from 'src/core/utils/object';
import { ConfigurationService } from 'src/core/services/configuration.service';
import { EmailDocumentService } from 'src/app/general/email-document-template/email-document.service';
import { Row, Col, Card, Radio } from 'antd';
import Menu from 'antd/lib/menu';

const RadioGroup = Radio.Group;

interface EmailTemplatePreviewViewParams {
	items: IEmailDocumentTemplateSummary[];
	onTemplateSelected: (templateId: number) => void;
}

export class EmailTemplatePreviewView extends React.Component<EmailTemplatePreviewViewParams, any> {


	constructor(props) {
		super(props);

		this.state = {
			templateId: 0
		}
	}
	

	public componentWillReceiveProps(nextProps) {
		if (nextProps.items.length > 0) {
			this.setState({
				templateId: nextProps.items[0].id
			});
		}
	}

	renderTemplate(item: IEmailDocumentTemplateSummary)
	{
		return (
			<div key={`container_${item.id}`} style={{ marginTop: 10, width:'100%' }}>
				<Radio value={item.id}>
					{item.name}
				</Radio>
				<div className='card card-borderless' style={{ width: '100%', marginTop:5, position:'relative' }}>
					<p><strong>Subject: </strong> {item.subject}</p>

					<div className='wysiwyg-editor-preview' dangerouslySetInnerHTML={{ __html: item.body }}>
					</div>
				</div>

			</div>
			)
	}

	render() {
		if (this.props.items.length == 0)
			return null;

		return (
			<RadioGroup value={this.state.templateId} onChange={(e: any) => {
				this.setState({ templateId: e.target.value as number});
				this.props.onTemplateSelected(e.target.value as number);
				}
			} defaultValue={this.props.items[0].id}>
				{this.props.items.map(this.renderTemplate)}
			</RadioGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/email-document-template/parts/email-template-preview.view.tsx